import { useMatches, useNavigate } from "react-router";
import { Button } from "@tricura/atlas-ui";
import { WorkInProgress } from "../../components/work-in-progress";
import { useSubmissionContext } from "./context";
import { getNextSection, getSectionById } from "./sections";

interface WorkInProgressPageProps {
    sectionId: string;
}

export function WorkInProgressPage({ sectionId }: WorkInProgressPageProps) {
    const navigate = useNavigate();
    const { detail } = useSubmissionContext();
    const section = getSectionById(sectionId);
    const next = getNextSection(sectionId);

    const goNext = () => {
        if (next) navigate(`/submissions/${detail.id}/${next.path}`);
        else navigate("/submissions");
    };

    // Route matches are accepted but we never read them here — kept so
    // a future version can branch on metadata without changing the API.
    useMatches();

    return (
        <>
            <WorkInProgress title={section?.label ?? "Section"} />
            <footer className="bg-primary flex items-center justify-end gap-3 px-8 py-4">
                <Button color="secondary" isDisabled>
                    Save Draft
                </Button>
                <Button color="primary" onClick={goNext}>
                    {next ? "Save & Continue" : "Back to submissions"}
                </Button>
            </footer>
        </>
    );
}
